import { Link } from 'react-router-dom';
import { Modal } from 'reactstrap';
import styled from 'styled-components';

export const Container = styled.div`
  margin: 10px;
`;

export const Header = styled.div`
  margin: 10px 30px 10px 30px;
  display: flex;
  justify-content: space-between;

  h2 {
    font-size: 30px;
    font-weight: bold;
  }
`;

export const Card = styled.div`
  margin: 0 auto;
  background: ${(props) => props.theme.colors.white};
  /* filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1)); */
  border-radius: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const AddKitchenCard = styled.button`
  width: 200px;
  height: 200px;
  color: #2ec9b7;
  border: 2px solid #2ec9b7;
  border-radius: 5px;
  background: #fff;

  p {
    color: #2ec9b7;
    font-weight: bold;
    margin-top: 10px;
    font-size: 18px;
  }
`;

export const ChooseKitchenCard = styled.div`
  position: relative;
  width: 150px;
  height: 108px;
  border: none;
  border-radius: 5px;
  background: #2ec9b7;

  text-decoration: none;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;

  flex-direction: column;

  svg {
    color: #fff;
  }

  p {
    color: #fff;
    font-weight: bold;
    margin-top: 10px;
    font-size: 18px;
  }
`;

export const LinkStyled = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 170px;
  height: 170px;
  flex-direction: column;
`;

export const InputStyled = styled.input`
  width: 65px;
  height: 38px;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  text-align: center;
  margin-right: 8px;
`;

export const KdsArea = styled.div`
  width: 100%;
`;

export const KdsOperationalArea = styled.div`
  width: 100%;
`;

export const KdsTypeTitle = styled.h2`
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #545454;
`;

export const KdsContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
`;

export const KdsOperationalContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;

  p {
    text-align: center;
  }
`;

export const KdsOperacionalItems = styled.div`
  display: ${(props) => {
    if (props.isOperational && props.isExpanded) {
      return 'flex';
    }
    return 'none';
  }};

  opacity: ${(props) => {
    if (props.isOperational && props.isExpanded) {
      return '1';
    }
    return '0';
  }};

  transition: all 0.3s ease;
`;

export const KdsOperationalTitle = styled.span`
  color: #545454;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`;

export const KdsOperationalHeader = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  gap: 8px;
`;

export const ModalStyled = styled(Modal)`
  .modal-content {
    width: 800px;
    max-height: 744px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    left: -120px;
  }

  .modal-header {
    padding: 16px;
    padding-bottom: 0px;
  }

  .modal-body {
    padding: 16px;
    flex: 1;
  }
`;
